export const BusinessNeeds = [
  {
    'label': 'Asset finance',
    'value': 'Asset finance'
  },
  {
    'label': 'Bridging finance',
    'value': 'Bridging finance'
  },
  {
    'label': 'Refinance existing debt',
    'value': 'Refinance existing debt'
  },
  {
    'label': 'Working capital',
    'value': 'Working capital'
  },
  {
    'label': 'Other',
    'value': 'Other'
  }
];
